import { useUser } from "@/contexts/UserContext";
import { Outlet, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

const ApproverGuard: React.FC = () => {
  const { isApprover, isLoading } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) return;
    if (!isApprover) navigate({ to: "/error/401" });
  }, [isLoading, isApprover, navigate]);
  if (isLoading || !isApprover) return null;
  return <Outlet />;
};

export default ApproverGuard;
